import React, { useContext, useEffect } from 'react';
import t from 'react-translate';

// Types
import { SessionTypes } from 'redux/schemas/models/live-event';

// Styles
import { css } from '@emotion/react';

// Components
import MSTeamsSettings from './ms-teams-settings';
import ZoomSettings from './zoom-settings';
import { LiveSessionFormContext } from './live-session-form';

const styles = css`
  border: 1px solid #e5e5e5;
`;

const getKeyForSessionType = (sessionType: SessionTypes) => (
  Object.keys(SessionTypes).find((key) => SessionTypes[key] === sessionType)
);

const LiveEventSettings = () => {
  const { sessionType } = useContext(LiveSessionFormContext);
  const [title, setTitle] = React.useState('');

  useEffect(() => {
    const sessionTypeKey = getKeyForSessionType(sessionType);
    setTitle(t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.MODAL.SETTINGS[sessionTypeKey]());
  }, [sessionType]);

  return (
    <div css={styles} className='p-4'>
      <div className='text-regular bold mb-2'>{title}</div>
      {sessionType === SessionTypes.ZOOM && <ZoomSettings />}
      {sessionType === SessionTypes.MS_TEAMS && <MSTeamsSettings />}
    </div>
  );
};

export default LiveEventSettings;
